import { useEffect, useRef, useState } from "react";

// Stepper numéroté pour un process en N étapes (titres seuls).
// Desktop : 6 cercles numérotés reliés par une ligne qui se trace au scroll.
// Mobile/tablette : cartes numérotées empilées. Apparition en cascade.
export default function ProcessFlow({ steps = [] }) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setShown(true);
          io.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} className="relative">
      {/* Ligne de liaison — horizontale sur desktop, verticale en mobile.
         Elle se trace au scroll dans les deux cas. */}
      <div className="pointer-events-none absolute left-[8.333%] right-[8.333%] top-8 hidden h-1 rounded-full bg-border lg:block">
        <div className={`h-full rounded-full bg-primary transition-all duration-[1600ms] ease-out ${shown ? "w-full" : "w-0"}`} />
      </div>
      <div className="pointer-events-none absolute left-[21px] top-6 bottom-6 w-0.5 rounded-full bg-border lg:hidden">
        <div className={`w-full rounded-full bg-primary transition-all duration-[1600ms] ease-out ${shown ? "h-full" : "h-0"}`} />
      </div>

      <ol className="grid grid-cols-1 gap-y-5 lg:grid-cols-6 lg:gap-x-6 lg:gap-y-8">
        {steps.map((s, i) => (
          <li
            key={s.title}
            style={{ transitionDelay: `${i * 110}ms` }}
            className={`relative flex items-center gap-4 text-left transition-all duration-500 ease-out lg:flex-col lg:gap-0 lg:text-center ${
              shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
            }`}
          >
            <div className="relative z-10 flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary font-display text-lg font-black text-white ring-4 ring-secondary lg:h-16 lg:w-16 lg:text-2xl">
              {i + 1}
            </div>
            <p className="text-[15px] font-semibold leading-snug text-primary lg:mt-5 lg:text-base">{s.title}</p>
          </li>
        ))}
      </ol>
    </div>
  );
}
